module.exports = __webpack_public_path__ + "static/media/py.33654bee.svg";